import {useEffect, useMemo, useRef} from "react";
import {ISlsOrd} from "../kova/slsordClient";
import {useStateId} from "../hooks/useStateId";
import {useVisualizerSession} from "../components/visualizer/VscVisualizerSession";
import {ILevelGroupSetting, IShow3DMode} from "../components/visualizer/VisualizerSessionManager";

import {IViewpoint, IViewpointGroup} from "../data/IViewpoint";

export function getUnrealId(slsOrd:ISlsOrd) {
    return slsOrd.unrealId;
}

interface IBigScreen3D {
    mode: IShow3DMode;
    camera:ICameraViewCamera|ICameraViewViewpoint|undefined;
    items: IBigScreenCommunity3DItems[];

    // The map to use in unreal, i.e. the name of the community asset.
    map?:string;
    /**
     * If specified, then there will be a car parked on the parking spot of a specific ISlsOrd. The second element is the car type,
     *
     */
    parkedCar?: [ISlsOrd, "EV"|"Gas"];

}

function useLevelGroups(items: IBigScreenCommunity3DItems[]) {

    const levelGroups: ILevelGroupSetting[] = [];

    for (const item of items) {
        const slsOrd = item.slsOrd;
        // We only touch sales orders which are available - sold sales orders should still have their roof on //
        if (!slsOrd.isSold) {
            levelGroups.push({lot: getUnrealId(slsOrd), levelGroup: item.levelGroup});
        }
    }
    return levelGroups;
}

export type ICameraViewCamera =
{
    type: "camera";
    cameraId: string;
}
export type ICameraViewViewpoint = {
    type: "viewpoint";
    viewpoint: IViewpoint;
    relativeTo?: string; // lot Id
}
export function useCamera(camera: ICameraViewCamera | ICameraViewViewpoint | undefined) {
    const visualizer = useVisualizerSession();
    const cameraKey = JSON.stringify(camera ?? {});
    useEffect(() => {
        if (camera === undefined) return;
        if (camera.type === "viewpoint") {

            const viewpoint = camera.viewpoint;
            visualizer.changeCameraToViewpoint(viewpoint, camera.relativeTo);
            return;
        }
        if (camera.type === "camera") {
            visualizer.changeCamera(camera.cameraId);
        }

        // We stringify camera because it is a calculated object and changes every time.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cameraKey, visualizer]);

}
export interface IHouseModelSetting {
    houseModel:string;
    lotId:string;
}
export const BigScreen3D: React.FC<{mode: IShow3DMode, map?: string}> = (props) => {

    const { mode, map} = props;
    const sessionId = useStateId([mode, map ?? ""]);
    const visualizerSession = useVisualizerSession();

    useEffect(() => {
        //if (camera === null) return;
        visualizerSession.show3d(sessionId, {
            mode,
            map
        });
    }, [ visualizerSession, sessionId]);
    return null;
}
export interface IParking {
    lot: string;
    show: boolean;

}
export interface ILotLabel {
    lot: string;
    label: string;
    color: string;
}
function useLotLabels(items: IBigScreenCommunity3DItems[]) {
    const retval: ILotLabel[] = [];
    for (const item of items) {
        const so = item.slsOrd;
        if (so.isSold) {
            retval.push({
                lot: getUnrealId(so),
                label: "Sold",
                color: "Red"
            });

        } else {
            retval.push({
                lot: getUnrealId(so),
                label: so.lotNumber,
                color: "Green"
            });
        }
    }
    return retval;
}
export interface IBigScreenCommunity3DItems {
    slsOrd: ISlsOrd;
    levelGroup: string;
    showParking: boolean;
}
function useParking2(items:IBigScreenCommunity3DItems[]) {
    const retval: IParking[] = [];

    for (const item of items) {
        retval.push({lot: getUnrealId(item.slsOrd), show: item.showParking});

    }
    return retval;
}
const BigScreenCommunity3D: React.FC<IBigScreen3D> = ({mode, camera, items, map}) => {
    useCamera(camera); // TODO support for community viewpoints?
    return <BigScreen3D mode={mode} map={map} />;
}
export default BigScreenCommunity3D;